<template>
  <v-container fluid class="mt-4 mr-2">
    <v-row>
      <v-card class="elevation-0 transparent">
        
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex'

  // require=require('esm')(module);
  import {Base64} from 'js-base64';

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  export default {

    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      usuarios:[],
      loading: 5,
    }),

    computed:{
      ...mapGetters('login',['getdatosUsuario'])
    },

    created(){
      this.initialize()
    },

    methods:{
      initialize () {
        this.usuarios = []
        this.cargar = true
        this.$http.get('accesos.all').then(response=>{
          for(const i in response.body){
            if(response.body[i].id == this.getdatosUsuario.id){
              this.usuarios = response.body[i]
            }
          }

          this.longitud = this.usuarios.length
          this.loading = false
          this.cargar = false
        }).catch(error=>{this.cargar = false})
      },

      ver(value){
        window.location = value.ruta + Base64.encode(this.getdatosUsuario.id)
      }
    }
  }

</script>

<style scoped>
  .padre{
    /*background: #11437C;  
    background: -webkit-linear-gradient(to right, #11437C, #12608D, #00B7D0);  
    background: linear-gradient(to right, #11437C, #12608D, #00B7D0);
*/
    background: #B30B0B;  
   /* background: -webkit-linear-gradient(to right, #B30B0B,  #FF6969);  
    background: linear-gradient(to right, #B30B0B,  #FF6969);*/

    align-items: center;
  }

  .hijo{
    font-size: calc(1em + 1vw);
    line-height: 150px;
    color: white;
    font-family: 'Times New Roman' !important;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }
</style>

